  document.addEventListener("DOMContentLoaded", evt => {
    var swiper = new Swiper(".advantages-thumbs", {
        spaceBetween: 0,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            1024: {
                slidesPerView: 6,
            },
            768: {
                slidesPerView: 4,
            },
            320: {
                slidesPerView: 3,
            },
        },
    });
    var swiper2 = new Swiper(".advantages-slider", {
        spaceBetween: 10,
        effect: "fade",
        speed: 300,
        thumbs: {
            swiper: swiper,
        },
    });
  });